import React, { useMemo } from 'react'
import zIndex from 'styles/tools/z-index'
import { bezierCurve } from 'styles/tools/constants'
import { rem } from 'polished'
import styled from 'styled-components'
import useLastNonEmptyValue from 'hooks/useLastNonEmptyValue'
import clsx from 'clsx'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import { connect } from 'react-redux'
import ExperienceRecentlyViewedTile from 'components/Experiences/ExperienceTiles/ExperienceRecentlyViewedTile'
import useSelectedItems from '../hooks/useSelectedItems'

const CarouselContainer = styled.div`
  position: absolute;
  padding: 0 ${rem(16)};
  padding-bottom: ${rem(16)};
  bottom: 0;
  transform: translateY(100%);
  left: 0;
  right: 0;
  z-index: ${zIndex.min};
  pointer-events: none;
  transition: transform .3s ${bezierCurve};
  width: 100%;

  &.show {
    pointer-events: auto;
    transform: translateY(0);
  }
`

interface MappedProps {
  experiences: Record<string, App.ExperienceOffer>
}

function ExperienceSearchMapCarousel(props: MappedProps) {
  const { experiences } = props
  const { selectedItemsIds } = useSelectedItems()

  // Holds the last selected offer IDs, so we can keep showing them while the carousel transitions out of the viewport
  const lastSelectedOfferIds = useLastNonEmptyValue(selectedItemsIds)
  const mappedExperiences = useMemo(() => lastSelectedOfferIds?.map(id => experiences[id]), [lastSelectedOfferIds, experiences])
  const selectedItemCount = selectedItemsIds?.length ?? 0

  return (
    <CarouselContainer className={clsx({ show: selectedItemCount > 0 })}>
      <CardCarousel width={rem(470)} alignment="center">
        {mappedExperiences?.map(experience => <React.Fragment key={experience?.id}>
          <ExperienceRecentlyViewedTile experience={experience} isMapView />
        </React.Fragment>)}
      </CardCarousel>
    </CarouselContainer>
  )
}

const mapStateToProps = (state: App.State) => ({
  experiences: state.experience.experiences,
})

export default connect(mapStateToProps)(ExperienceSearchMapCarousel)
